import type { ProjectMemberTreeNode } from '@/api/projectApi';

const ORG_CACHE_TTL_MS = 5 * 60 * 1000;

type CacheEntry<T> = { data: T; at: number };

let memberTreeCache: CacheEntry<ProjectMemberTreeNode[]> | null = null;

function isFresh<T>(entry: CacheEntry<T> | null | undefined): entry is CacheEntry<T> {
  return !!entry && Date.now() - entry.at < ORG_CACHE_TTL_MS;
}

export function invalidateSessionOrgCache() {
  memberTreeCache = null;
}

export async function getCachedMemberCandidateTree(
  fetcher: () => Promise<ProjectMemberTreeNode[]>,
): Promise<ProjectMemberTreeNode[]> {
  if (isFresh(memberTreeCache)) {
    return memberTreeCache.data;
  }
  const data = await fetcher();
  memberTreeCache = { data, at: Date.now() };
  return data;
}
